export default {"src":"/_next/static/media/logo-short.9a55f873.svg","height":187,"width":768,"blurWidth":0,"blurHeight":0};